// モック用の変数を定義
const MOCK_START_TIME = ref<number | null>(null);
const MOCK_SPEED_CHANGE_TIME = 15000; // 15秒後に速度を下げる
const MOCK_HIGH_SPEED = 5.56; // 初期速度: 約20km/h（速度超過）
const MOCK_LOW_SPEED = 2.78; // 減速後の速度: 約10km/h（制限内）

/**
   * モック位置情報を生成する関数
   * @returns モックの位置情報
   */
export const getMockPosition = (): GeolocationPosition => {
  const logger = useLogger('0-00');
  // モック開始時間を記録
  if (MOCK_START_TIME.value === null) {
    MOCK_START_TIME.value = Date.now();
    logger.debug('モック位置情報の速度シミュレーション開始');
  }

  const currentTime = Date.now();
  const elapsedTime = currentTime - (MOCK_START_TIME.value || 0);

  // 経過時間に基づいて速度を決定
  const speed = elapsedTime < MOCK_SPEED_CHANGE_TIME
    ? MOCK_HIGH_SPEED
    : MOCK_LOW_SPEED;

  // 速度変化のログ出力
  if (elapsedTime >= MOCK_SPEED_CHANGE_TIME && elapsedTime < MOCK_SPEED_CHANGE_TIME + 1000) {
    logger.debug(`モック位置情報: 速度が下がりました (${Math.round(speed * 3.6)}km/h)`);
  }

  // 移動経路をシミュレート（時間経過で少しずつ位置を変える）
  const angleOffset = (elapsedTime % 60000) / 60000 * 2 * Math.PI; // 1分で一周
  const circleRadius = 0.005; // 半径約500m相当

  // 基準位置
  const baseLatitude = 35.681236;
  const baseLongitude = 139.767125;

  // 速度に応じた位置のノイズ
  const positionNoise = speed > 3 ? 0.0002 : 0.0001;

  return {
    coords: {
      latitude: baseLatitude
        + Math.sin(angleOffset) * circleRadius + (Math.random() - 0.5) * positionNoise,
      longitude: baseLongitude
        + Math.cos(angleOffset) * circleRadius + (Math.random() - 0.5) * positionNoise,
      accuracy: 10,
      altitude: null,
      altitudeAccuracy: null,
      heading: null,
      speed: speed,
    },
    timestamp: currentTime,
  } as GeolocationPosition;
};

/**
   * モック位置情報をリセットする関数
   */
export const resetMockPosition = (): void => {
  MOCK_START_TIME.value = null;
  useLogger('0-00').debug('モック位置情報をリセットしました');
};
